import {BrowserRouter,Routes,Route, Router} from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Projects from './pages/Projects'
import Contact from './pages/Contact'
import Nucoin from './pages/nucoin'
import Ledgerx from './pages/Ledger_x'
import Facebook from './pages/Facebook'
import Insidecrypto from './pages/Insidecrypto'
import Roadmap from './pages/Roadmap'
import Explorer from './pages/explorer'
import ExplorerTransection from './pages/explorer_transection'
import SellNUC from './pages/sell_nuc'
import NoPage from './pages/NoPage'


import TextSummarize from './pages/ai/text_summarize'
import TextParaphrase from './pages/ai/text_paraphrase'
import TextGrammer from './pages/ai/text_grammer'
import TextAnalyze from './pages/ai/text_analyze_sentiment'
import CryptoInsightsBot from './pages/ai/crypto_insights_bot'
import CryptoCompare from './pages/ai/crypto_compare'
import InsightsCryptoNewsHub from './pages/ai/insights_crypto_news_hub'
import DreamInterpretation from './pages/ai/dream_Interpretation'
import DigitalKyc from './pages/ai/digital_kyc'
import Deepfake from './pages/ai/deepfake'
import CryptoTutor from './pages/ai/crypto_tutor'
import Lawyer from './pages/ai/lawyer'
import Fitness from './pages/ai/fitness'
import Tutor from './pages/ai/tutor'
import Chefmate from './pages/ai/chefmate'
import Chatscraper from './pages/ai/chatscraper'
import AiChat from './pages/ai/ai_chat'

// import CompareDashboard from './pages/ai/compare_dasboard'
import Valuation_report from './pages/pitch_deck/valuation_report'
import Community from './pages/pitch_deck/community'
import TiDepartment from './pages/pitch_deck/ti_department'
import Medical from './pages/pitch_deck/medical'
import Ai_department from './pages/pitch_deck/ai_department'
import Pdg from './pages/pitch_deck/pdg'
import Summary from './pages/pitch_deck/summary'
import Nft from './pages/pitch_deck/nft'
import Prediction from './pages/pitch_deck/prediction'
import MediaStream from './pages/pitch_deck/media_stream'
import BusinessResources from './pages/pitch_deck/business_resources'
import Videos from './pages/pitch_deck/videos'
import PrivacyPolicy from './pages/mobile-app/PrivacyPolicy'
import TermsConditions from './pages/mobile-app/TermsConditions'
import Login from './pages/dashboard/Login';
import DashboardSellNuc from './pages/dashboard/Dashboard_sell_nuc';

function App() {
  return (
    <div class="App">
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/en' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/nucoin' element={<Nucoin />} />
          <Route path='/ledgerx' element={<Ledgerx />} />
          <Route path='/insidecrypto' element={<Insidecrypto />} />
          <Route path='/facebook' element={<Facebook />} />
          <Route path='/airtable' element={<Roadmap />} />
          <Route path='/roadmap' element={<Roadmap />} />
          <Route path='/explorer' element={<Explorer />} />
          <Route path='/textsummarize' element={<TextSummarize />} />
          <Route path='/textparaphrase' element={<TextParaphrase />} />
          <Route path='/textgrammer' element={<TextGrammer />} />
          <Route path='/textanalyze' element={<TextAnalyze />} />
          <Route path='/cryptoinsightsbot' element={<CryptoInsightsBot />} />
          <Route path='/insightscryptonewshub' element={<InsightsCryptoNewsHub />} />
          <Route path='/dreamInterpretation' element={<DreamInterpretation />} />
          <Route path='/valuation_report' element={<Valuation_report />} />
          <Route path='/community' element={<Community />} />
          <Route path='/pdg' element={<Pdg />} />
          <Route path='/ti_department' element={<TiDepartment />} />
          <Route path='/medical' element={<Medical />} />
          <Route path='/ai_department' element={<Ai_department />} />
          <Route path='/summary' element={<Summary />} />
          <Route path='/nft' element={<Nft />} />
          <Route path='/prediction' element={<Prediction />} />
          <Route path='/media_stream' element={<MediaStream />} />
          <Route path='/business_resources' element={<BusinessResources />} />
          <Route path='/videos' element={<Videos />} />
          <Route path='/mobile-app/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/mobile-app/terms-conditions' element={<TermsConditions />} />
          <Route path='/crypto_compare' element={<CryptoCompare />} />
          <Route path='/cryptotutor' element={<CryptoTutor />} />
          <Route path='/digitalkyc' element={<DigitalKyc />} />
          <Route path='/deepfake' element={<Deepfake />} />
          <Route path='/explorer_transection' element={<ExplorerTransection />} />
          <Route path='/sell_nuc' element={<SellNUC />} />
          <Route path='/login' element={<Login />} />
          <Route path='/dashboard_sell_nuc' element={<DashboardSellNuc />} />
          <Route path='/lawyer' element={<Lawyer />} />
          <Route path='/fitness' element={<Fitness />} />
          <Route path='/tutor' element={<Tutor />} />
          <Route path='/chefmate' element={<Chefmate />} />
          <Route path='/chatscraper' element={<Chatscraper />} />
          <Route path='/chatty' element={<AiChat />} />
          {/* <Route path="/compare_dasboard" element={<CompareDashboard />} /> */}
          
          <Route path='*' element={<NoPage />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
